import React, { useState, useEffect } from "react";
import "./Homepage.css";
import { Fade, Zoom } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import IntegratedLearningDiagram from "./Integratedlearningdiagram";

function Homepage() {
  const navigate = useNavigate();

  const phrases = [
    "500+ Hours of Drone Training Content",
    "Easy-to-Use Indian-Made Drones",
    "Empowering Future Innovators",
  ];

  const accordionData = [
    {
      title: "What makes Zuppa LMS ideal for educational institutions?",
      content:
        "Zuppa LMS is specifically designed to equip institutions with everything they need to teach drone technology effectively, including 500+ hours of expert-curated content and hands-on support.",
    },
    {
      title: "What type of support does Zuppa offer for drone labs?",
      content:
        "Zuppa provides end-to-end solutions including supplying drones, assisting with lab setup, and offering continuous training and technical support.",
    },
    {
      title: "Why should Educational institutions focus on drone education?",
      content:
        "The drone industry is rapidly growing across agriculture, defense and logistics. Zuppa LMS prepares students with industry-ready knowledge.",
    },
    {
      title: "Why are Zuppa’s drones ideal for educational purposes?",
      content:
        "Our drones are cyber-secure, user-friendly and specifically designed for educational institutions.",
    },
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];

    if (isTyping) {
      if (displayedText.length < currentPhrase.length) {
        const timeout = setTimeout(() => {
          setDisplayedText(
            currentPhrase.substring(0, displayedText.length + 1),
          );
        }, 100);

        return () => clearTimeout(timeout);
      } else {
        const pause = setTimeout(() => setIsTyping(false), 1500);
        return () => clearTimeout(pause);
      }
    } else {
      if (displayedText.length > 0) {
        const erase = setTimeout(() => {
          setDisplayedText(
            currentPhrase.substring(0, displayedText.length - 1),
          );
        }, 50);

        return () => clearTimeout(erase);
      } else {
        setIsTyping(true);
        setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
      }
    }
  }, [displayedText, isTyping, currentPhraseIndex]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* HERO */}

      <div className="zuppa_lms_hopg_hero_container">
        <div className="zuppa_lms_hopg_hero_text">
          <h2 className="zuppa_lms_hopg_hero_subheading">
            Revolutionizing Education, One Flight at a Time
          </h2>

          <h1 className="zuppa_lms_hopg_hero_heading">{displayedText}</h1>

          <h2 className="zuppa_lms_hopg_hero_subheading">
            Join the Drone Education Revolution Today!
          </h2>

          <div className="zuppa_lms_hopg_hero_buttons">
            <button
              className="zuppa_lms_hopg_hero_button"
              onClick={() => navigate("/lms/contact")}
            >
              Join / Contact us
            </button>
          </div>
        </div>

        <img
          className="zuppa_lms_hopg_hero_image"
          src="https://res.cloudinary.com/dwrwkl5b3/image/upload/v1772880773/homefirst_qidhko.png"
          alt="hero"
        />
      </div>
<br/>



      {/* ABOUT */}

      <div className="zuppa_lms_hopg_container">
        <div className="zuppa_lms_hopg_content">
          <h2 className="zuppa_lms_hopg_section_heading">ABOUT US</h2>

          <p>
            At Zuppa Geo Navigation Technologies, we are redefining the
            boundaries of innovation in drone education. As India’s only company
            with a patented computing architecture for drone autopilots , we
            lead the way in technological advancements and education solutions.
          </p>

          <p>Exclusive Indian manufacturer of cyber-secure drones</p>

          <p>Trusted supplier of drone autopilots to DRDO and DPSUs</p>

          <p>
            India’s first internationally certified aerospace manufacturer for
            drones and electronics.
          </p>

          <p>
            With Zuppa Learning Management System (ZLMS) ,we bridge the gap
            between academia and technology. Our platform offers 500+ hours of
            engaging video content, enabling educational institutions to set up
            drone labs and nurture the next generation of drone professionals.
          </p>
        </div>
<Zoom duration={3000}>
 
        <div className="zuppa_lms_hopg_image_wrapper">
          <IntegratedLearningDiagram />
        </div>
        </Zoom>
      </div>

      {/* WHY CHOOSE */}

      <div className="zuppa_lms_hopg_container_reverse">
        <div className="zuppa_lms_hopg_content">
          <h2 className="zuppa_lms_hopg_section_heading">
            WHY CHOOSE OUR LMS?
          </h2>

          <p>
            Comprehensive Drone Education Platform providing in-depth content on
            drone design, operation, and applications.
          </p>

          <p>
            Industry Partnerships and Expertise Leverage our trusted reputation
            as a vendor to DRDO and DPSUs for unmatched expertise and
            reliability.
          </p>

          <p>
            500+ Hours of Premium Content Give students access to video
            tutorials, case studies, and simulations that make drone technology
            accessible and exciting.
          </p>

          <p>
            Indian-Made,Cyber-Secure Drones with hands-on experience using
            easy-to-operate drones that meet global quality standards.
          </p>

          <p>
            End-to-end support to ensure seamless integration of drone education
            into your curriculum
          </p>
        </div>

        <div className="zuppa_lms_hopg_image_wrapper">
          <img
            src="https://res.cloudinary.com/dwrwkl5b3/image/upload/v1772683524/AJEET_Mini_Scout_Plus_Front_x3q0vz.png"
            className="zuppa_lms_hopg_second_image"
            alt="drone"
          />
        </div>
      </div>

      {/* FAQ */}

      <div className="zuppa_lms_hopg_accordion_section">
        <h2 className="zuppa_lms_hopg_faq_heading">
          LMS Frequently Asked Questions
        </h2>

        {accordionData.map((item, index) => (
          <div key={index} className="zuppa_lms_hopg_accordion">
            <button
              className="zuppa_lms_hopg_accordion_header"
              onClick={() => toggleAccordion(index)}
            >
              {item.title}

              <span>{activeIndex === index ? "-" : "+"}</span>
            </button>

            {activeIndex === index && (
            
                <div className="zuppa_lms_hopg_accordion_content">
                  {item.content}
                </div>
           
            )}
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}

export default Homepage;
